module.exports = __webpack_public_path__ + "img/maintext.eb905a21.svg";